module.exports = {
    "frames": [
        {
            "time": 0,
            "image": require("@frog/source/assets/images/bomber-tactics/units/red/launch/1_.png").default
        },
        {
            "time": 100,
            "image": require("@frog/source/assets/images/bomber-tactics/units/red/launch/2_.png").default
        },
        {
            "time": 200,
            "image": require("@frog/source/assets/images/bomber-tactics/units/red/launch/3_.png").default
        },
        {
            "time": 300,
            "image": require("@frog/source/assets/images/bomber-tactics/units/red/launch/4_.png").default
        },
        {
            "time": 400,
            "image": require("@frog/source/assets/images/bomber-tactics/units/red/launch/5_.png").default
        },
        {
            "time": 500,
            "image": require("@frog/source/assets/images/bomber-tactics/units/red/launch/6_.png").default
        },
        {
            "time": 600,
            "image": require("@frog/source/assets/images/bomber-tactics/units/red/launch/7_.png").default,
            "duration": 50,
        },
        {
            "time": 650,
            "image": require("@frog/source/assets/images/bomber-tactics/units/red/launch/8_.png").default
        },
        {
            "time": 750,
            "image": require("@frog/source/assets/images/bomber-tactics/units/red/launch/9_.png").default
        },
        {
            "time": 850,
            "image": require("@frog/source/assets/images/bomber-tactics/units/red/launch/10_.png").default
        },
        {
            "time": 950,
            "image": require("@frog/source/assets/images/bomber-tactics/units/red/launch/11_.png").default
        },
        {
            "time": 1050,
            "image": require("@frog/source/assets/images/bomber-tactics/units/red/launch/12_.png").default
        },
        {
            "time": 1150,
            "image": require("@frog/source/assets/images/bomber-tactics/units/red/ready/1_.png").default
        }
    ]
}
